import { create } from 'zustand';

/**
 * Cuenta cuántos paneles flotantes (Drawer) están abiertos a la vez, para que
 * elementos como el tour guiado puedan ocultarse mientras uno esté abierto y
 * reaparecer solos al cerrarse — sin perder ni alterar su propio progreso.
 */
interface EstadoPanelesFlotantes {
  contador: number;
  abrirPanel: () => void;
  cerrarPanel: () => void;
}

export const usePanelesFlotantesStore = create<EstadoPanelesFlotantes>((set) => ({
  contador: 0,
  abrirPanel: () => set((s) => ({ contador: s.contador + 1 })),
  cerrarPanel: () => set((s) => ({ contador: Math.max(0, s.contador - 1) })),
}));

export const usePanelFlotanteAbierto = (): boolean =>
  usePanelesFlotantesStore((s) => s.contador > 0);
